export const bs = {
    LEFT: 'Ostavio: Potez na prethodni dan.',
    RIGHT: 'Desno: Preseliti u slijedeći dan.',
    DOWN: 'Dole: Preseliti u slijedeći red.',
    UP: 'Gore: Preseliti u prethodnom red.',
    PGUP: 'PgUp: Potez na prethodni mesec dana.',
    PGDOWN: 'PgDown: Preseliti u slijedeći mjesec.',
    HOME: 'Kući: Preseliti na prethodne godine.',
    END: 'Kraju: Potez do sledeće godine.',
    ESC: 'J/Danas/Blizu: blizu kalendar.',
    TITLE: 'Tastaturu Instrukcije'
};
